import { useQueryParams } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useAllowedCurrencyForSubsidiary } from "../../../hooks/useAllowedCurrencyForSubsidiary";
import { useClientAccount } from "../../../hooks/useClientAccount";
import { Subsidiary } from "../../../types";

export function CurrencyFilter(props: { isLoading: boolean }) {
  const { getParamsAsArray, setParam } = useQueryParams();
  const { client } = useClientAccount();
  const { t } = useTranslation();

  const paramKey = "currency";
  const allowedCurrencies = useAllowedCurrencyForSubsidiary(
    client?.subsidiary as Subsidiary,
    true
  );

  return (
    <Picker
      isLoading={props.isLoading}
      showActionBar
      selectedKeys={getParamsAsArray(paramKey)}
      onSelectionChange={(keys) =>
        setParam(paramKey, Array.from(keys).map(String), true)
      }
      label={t("Billing currency")}
      items={allowedCurrencies}
      selectionMode="multiple"
      testID="currency-type-filter"
    />
  );
}
